import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { OrganizationPersonalApiKey } from "../../types";

const ApiKeysPersonalTableOwnerCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<OrganizationPersonalApiKey>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {apiKey.owner && <TableCellText>{apiKey.owner}</TableCellText>}
      {!apiKey.owner && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default ApiKeysPersonalTableOwnerCell;
